import LocatieInfoImport from '../components/LocatieInfoImport';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import * as XLSX from 'xlsx';
import api from '../services/api';
import './Import.css';

const Import = () => {
  const { terms } = useAuth();
  const { gebruiker } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('klanten');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState([]);
  const normMat = (r) => {
    const o = {};
    Object.keys(r).forEach(k => {
      const kk = String(k).toLowerCase().replace(/\(.*?\)/g, '').replace(/[^a-z]/g, '');
      const v = r[k];
      if (kk === 'naam' || kk === 'omschrijving') o.naam = v;
      else if (['artikelnummer', 'artikelnr', 'artnr', 'code'].includes(kk)) o.code = v;
      else if (kk === 'categorie') o.categorie = v;
      else if (['prijs', 'verkoopprijs', 'prijsperstuk'].includes(kk) || kk.startsWith('prijs')) o.verkoopprijs = v;
      else if (kk === 'eenheid') o.eenheid = v;
    });
    return o;
  };
  const [importing, setImporting] = useState(false);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(null);
const [pdfCodes, setPdfCodes] = useState([]);
  const [pdfMerk, setPdfMerk] = useState('');
  const [pdfLoading, setPdfLoading] = useState(false);
const handlePDFUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPdfLoading(true);
    setPdfCodes([]);
    const formData = new FormData();
    formData.append('pdf', file);
    try {
      const res = await api.post('/kennisbank/upload-pdf', formData);
      if (res.data.success) {
        setPdfCodes(res.data.codes || []);
      } else {
        setErrors([res.data.message]);
      }
    } catch (err) {
      setErrors([err.message]);
    }
    setPdfLoading(false);
  };

  const handleKennisbankImport = async () => {
    if (!pdfMerk || pdfCodes.length === 0) {
      alert('Vul een merk in');
      return;
    }
    setImporting(true);
    try {
      const res = await api.post('/kennisbank/importeer', {
        merk: pdfMerk,
        codes: pdfCodes,
        bedrijf_id: 1
      });
      if (res.data.success) {
        setSuccess('✅ ' + res.data.toegevoegd + ' codes geïmporteerd!');
        setPdfCodes([]);
        setPdfMerk('');
      }
    } catch (err) {
      setErrors([err.message]);
    }
    setImporting(false);
  }; 

 const handleFileUpload = (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;
    setFile(uploadedFile);
    setErrors([]);
    setSuccess(null);
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet).map(r => activeTab === 'materialen' ? normMat(r) : r);
        if (jsonData.length === 0) {
          setErrors(['Het bestand is leeg']);
          return;
        }
        const validationErrors = validateData(jsonData);
        if (validationErrors.length > 0) {
          setErrors(validationErrors);
          setPreview([]);
        } else {
          setPreview(jsonData);
        }
      } catch (error) {
        setErrors(['Fout bij lezen bestand: ' + error.message]);
      }
    };
    reader.readAsBinaryString(uploadedFile);
  };

  const validateData = (data) => {
    const errors = [];
    if (activeTab === 'klanten') {
      data.forEach((row, idx) => {
        if (!row.naam || row.naam.trim() === '') {
          errors.push(`Rij ${idx + 2}: Naam is verplicht`);
        }
      });
    } else if (activeTab === 'materialen') {
      data.forEach((row, idx) => {
        if (!row.naam || row.naam.trim() === '') {
          errors.push(`Rij ${idx + 2}: Naam is verplicht`);
        }
      });
    } else {
      data.forEach((row, idx) => {
        if (!row.titel || row.titel.trim() === '') {
          errors.push(`Rij ${idx + 2}: Titel is verplicht`);
        }
        if (!row.afdeling) {
          errors.push(`Rij ${idx + 2}: Afdeling is verplicht`);
        }
      });
    }
    return errors;
  };

  const downloadTemplate = () => {
    const wb = XLSX.utils.book_new();
    let data, filename;
    if (activeTab === 'klanten') {
      data = [{ naam: 'Voorbeeld Bedrijf BV', categorie: 'Zakelijk', adres: 'Hoofdstraat 123', postcode: '1234AB', plaats: 'Amsterdam', telefoonnummer: '020-1234567', email: 'info@voorbeeld.nl', contactpersoon: 'Jan Jansen' }];
      filename = 'klanten_import_template.xlsx';
    } else if (activeTab === 'materialen') {
      data = [{ 'Naam': 'Koperen buis 15mm', 'Artikelnummer': 'KOP15', 'Categorie': 'Installatie', 'Prijs': 4.95, 'Eenheid': 'meter' }, { 'Naam': 'Montagedraad 2,5mm² blauw', 'Artikelnummer': 'MD25-BL', 'Categorie': 'Elektra', 'Prijs': 0.45, 'Eenheid': 'meter' }];
      filename = 'materialen_import_template.xlsx';
    } else {
      data = [{ titel: 'Voorbeeld werkorder', beschrijving: 'Beschrijving', afdeling: 'S&T', klant: 'Voorbeeld Bedrijf BV', locatie_adres: 'Hoofdstraat 123', prioriteit: 'normaal', geplande_datum: '2026-01-15', ordernummer: 'WO-2026-001' }];
      filename = 'werkorders_import_template.xlsx';
    }
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Template');
    XLSX.writeFile(wb, filename);
  };

  const handleImport = async () => {
    if (preview.length === 0) return;
    setImporting(true);
    setErrors([]);
    try {
      let endpoint;
      if (activeTab === 'klanten') endpoint = '/klanten/bulk';
      else if (activeTab === 'materialen') endpoint = '/materialen/bulk';
      else endpoint = '/werkorders/bulk';
      const response = await api.post(endpoint, preview, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      setSuccess(`✅ ${response.data.imported || preview.length} ${activeTab} succesvol geïmporteerd!`);
      setPreview([]);
      setFile(null);
      document.querySelector('input[type="file"]').value = '';
    } catch (error) {
      setErrors([error.response?.data?.message || 'Fout bij importeren']);
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="import-page">
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>📥 Bulk Import</h1>
        </div>
        <div className="import-content">
          <div className="tabs">
            <button className={`tab ${activeTab === 'klanten' ? 'active' : ''}`} onClick={() => { setActiveTab('klanten'); setPreview([]); setFile(null); setErrors([]); }}>📍 Klanten</button>
            <button className={`tab ${activeTab === 'werkorders' ? 'active' : ''}`} onClick={() => { setActiveTab('werkorders'); setPreview([]); setFile(null); setErrors([]); }}>📋 Werkorders</button>
            <button className={`tab ${activeTab === 'materialen' ? 'active' : ''}`} onClick={() => { setActiveTab('materialen'); setPreview([]); setFile(null); setErrors([]); }}>📦 Materialen</button>
            <button className={`tab ${activeTab === 'kennisbank' ? 'active' : ''}`} onClick={() => { setActiveTab('kennisbank'); setPreview([]); setFile(null); setErrors([]); }}>📚 Kennisbank</button>
            <button className={`tab ${activeTab === 'locatieinfo' ? 'active' : ''}`} onClick={() => { setActiveTab('locatieinfo'); setPreview([]); setFile(null); setErrors([]); }}>📋 Locatie-info</button>
          </div>

          <div className="import-instructions">
            <h3>Instructies:</h3>
            {activeTab === 'klanten' ? (
              <>
                <p>Upload een Excel bestand met: <strong>naam</strong> (verplicht), categorie, adres, postcode, plaats, telefoonnummer, email, contactpersoon</p>
                <button onClick={downloadTemplate} className="btn-download-template">📥 Download Template</button>
              </>
            ) : activeTab === 'materialen' ? (
              <>
                <p>Upload een Excel bestand met: <strong>Naam</strong> (verplicht), Artikelnummer, Categorie, Prijs (€ per eenheid), Eenheid. Bestaande artikelnummers worden bijgewerkt.</p>
                <button onClick={downloadTemplate} className="btn-download-template">📥 Download Template</button>
              </>
              ) : activeTab === 'locatieinfo' ? (
              <LocatieInfoImport />
              ) : activeTab === 'kennisbank' ? (
              <>
                <p>Upload een <strong>PDF</strong> met foutcodes. Het systeem scant automatisch de codes eruit.</p>
              </>

            ) : (
              <>
                <p>Upload een Excel bestand met: <strong>titel</strong> (verplicht), <strong>afdeling</strong> (verplicht), beschrijving, klant, locatie_adres, prioriteit, geplande_datum, ordernummer</p>
                <button onClick={downloadTemplate} className="btn-download-template">📥 Download Template</button>
              </>
            )}
          </div>
  <div className="upload-section">
            {activeTab === 'kennisbank' ? (
              <>
                <input type="file" accept=".pdf" onChange={handlePDFUpload} id="pdf-upload" style={{ display: 'none' }} />
                <label htmlFor="pdf-upload" className="btn-upload">📄 Kies PDF Bestand</label>
                {pdfLoading && <span style={{marginLeft:10}}>⏳ Scannen...</span>}
              </>
            ) : (
              <>
                <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileUpload} id="file-upload" style={{ display: 'none' }} />
                <label htmlFor="file-upload" className="btn-upload">📁 Kies Excel Bestand</label>
                {file && <span className="file-name">📄 {file.name}</span>}
              </>
            )}
          </div>

          {activeTab === 'kennisbank' && pdfCodes.length > 0 && (
            <div className="preview-section">
              <h3>✅ {pdfCodes.length} codes gevonden</h3>
              <input type="text" placeholder="Merk (bijv. Hanning & Kahl)" value={pdfMerk} onChange={e => setPdfMerk(e.target.value)} style={{ padding: 10, marginRight: 10, marginBottom: 10, borderRadius: 6, border: '1px solid #ccc', width: 250 }} />
              <button onClick={handleKennisbankImport} disabled={importing} className="btn-import">{importing ? '⏳...' : '📥 Importeer'}</button>
              <table style={{marginTop:10}}><thead><tr><th>Code</th><th>Titel</th></tr></thead>
              <tbody>{pdfCodes.slice(0,10).map((c,i) => <tr key={i}><td>{c.code}</td><td>{c.titel}</td></tr>)}</tbody></table>
            </div>
          )}

          {errors.length > 0 && (
            <div className="error-messages">
              {errors.map((err, i) => <p key={i} className="error">{err}</p>)}
            </div>
          )}

          {success && <div className="success-message">{success}</div>}

          {preview.length > 0 && (
            <div className="preview-section">
              <h3>Preview (eerste {Math.min(preview.length, 10)} rijen):</h3>
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      {activeTab === 'klanten' ? (
                        <><th>Naam</th><th>Categorie</th><th>Adres</th><th>Postcode</th><th>Plaats</th><th>Telefoon</th><th>Email</th></>
                      ) : activeTab === 'materialen' ? (
                        <><th>Naam</th><th>Artikelnummer</th><th>Categorie</th><th>Prijs</th><th>Eenheid</th></>
                      ) : (
                        <><th>Titel</th><th>Afdeling</th><th>{terms?.klant_singular || "Klant"}</th><th>Prioriteit</th><th>Geplande datum</th></>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {preview.slice(0, 10).map((row, idx) => (
                      <tr key={idx}>
                        {activeTab === 'klanten' ? (
                          <><td>{row.naam}</td><td>{row.categorie || '-'}</td><td>{row.adres || '-'}</td><td>{row.postcode || '-'}</td><td>{row.plaats || '-'}</td><td>{row.telefoonnummer || '-'}</td><td>{row.email || '-'}</td></>
                        ) : activeTab === 'materialen' ? (
                          <><td>{row.naam}</td><td>{row.code || '-'}</td><td>{row.categorie || '-'}</td><td>{row.verkoopprijs !== undefined && row.verkoopprijs !== '' ? '€ ' + row.verkoopprijs : '-'}</td><td>{row.eenheid || 'stuk'}</td></>
                        ) : (
                          <><td>{row.titel}</td><td>{row.afdeling}</td><td>{row.klant || '-'}</td><td>{row.prioriteit || 'normaal'}</td><td>{row.geplande_datum || '-'}</td></>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="import-actions">
                <p><strong>Totaal:</strong> {preview.length} {activeTab}</p>
                <button onClick={handleImport} disabled={importing} className="btn-import">
                  {importing ? '⏳ Importeren...' : `✅ ${preview.length} ${activeTab} importeren`}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Import;

